import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IAutoDownloadSetting } from "@app/interfaces/IAutoDownloadSetting";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AutoDownloadSettingService {
    constructor(
        private readonly httpClient: HttpClient
    ) { }

    getData(): Observable<IAutoDownloadSetting[]> {
        const options = { params: {} as HttpParams }
        options.params["isActive"] = true;

        return this.httpClient.get<IAutoDownloadSetting[]>(`/api/autodownloadsetting`, options);
    }

    getNumberOfEvents(eventCode: number): Observable<number> {
        const options = { params: {} as HttpParams }

        options.params["eventCode"] = eventCode;
        options.params["days"] = 30;

        return this.httpClient.get<number>(`/api/autodownloadsetting/numberofevents`, options);
    }

    
    getNumberOfVehicles(): Observable<number> {        
        return this.httpClient.get<number>(`/api/autodownloadsetting/numberofvehicles`);
    }

    save(setting: IAutoDownloadSetting): Observable<void> {
        return this.httpClient.post<void>(`/api/autodownloadsetting`, setting);
    }


    delete(settingId: number): Observable<void> {
        return this.httpClient.post<void>(`/api/autodownloadsetting/delete`, settingId);
    }

    createDefaultSetting(): IAutoDownloadSetting {
        const newSetting: IAutoDownloadSetting = {
            Id: null,
            AccountId: null,
            EventType: null,
            VideoDuration: 10,
            IsHighDefinition: true,
            Channels: [],
            IsActive: true,
            CreatedTime: null,
            UpdatedTime: null
        }

        return newSetting;
    }
}
